import React, { useState } from 'react';
import Button from '../UI/Button';
import { exportToPDF } from '../../utils/exportPDF';
import { exportToDOCX } from '../../utils/exportDOCX';
import { useNavigate } from 'react-router-dom';

export default function ResumeActions({ resume, onAction }) {
	const [open, setOpen] = useState(false);
	const navigate = useNavigate();

	async function doExport(type) {
		if (type === 'pdf') {
			await exportToPDF('resume-preview', `${(resume.title || 'resume').replace(/[^a-z0-9-_]+/gi, '_')}.pdf`);
		} else {
			await exportToDOCX(resume, `${(resume.title || 'resume').replace(/[^a-z0-9-_]+/gi, '_')}.docx`);
		}
	}

	return (
		<div className="relative">
			<Button variant="ghost" onClick={() => setOpen((v) => !v)}>
				Actions
			</Button>
			{open && (
				<div className="absolute right-0 mt-2 w-56 bg-white border rounded shadow z-10">
					<Action onClick={() => navigate(`/resumes/${resume._id}/edit`)}>Edit Resume</Action>
					<Action onClick={() => navigate(`/resumes/${resume._id}/preview`)}>Preview Resume</Action>
					<Action onClick={() => onAction?.('analyze')}>Analyze with ATS</Action>
					<Action onClick={() => onAction?.('match')}>Match with Jobs</Action>
					<Action onClick={() => onAction?.('duplicate')}>Duplicate Resume</Action>
					<Action onClick={() => doExport('pdf')}>Export PDF</Action>
					<Action onClick={() => doExport('docx')}>Export DOCX</Action>
					<Action onClick={() => onAction?.('share')}>Share Link</Action>
					<Action onClick={() => onAction?.('delete')} danger>
						Delete Resume
					</Action>
				</div>
			)}
		</div>
	);
}

function Action({ children, onClick, danger }) {
	return (
		<button className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-50 ${danger ? 'text-red-600' : ''}`} onClick={onClick}>
			{children}
		</button>
	);
}


